import { render } from "./whatsapp-button.vue?vue&type=template&id=0f239cf9"
import script from "./whatsapp-button.vue?vue&type=script&lang=js"
export * from "./whatsapp-button.vue?vue&type=script&lang=js"

import "./whatsapp-button.vue?vue&type=style&index=0&id=0f239cf9&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__